import { FC } from "react";
import "./style.scss";
import { Link } from "react-router-dom";

interface IUniversityProgramsCard {
  currentTab: string;
  name: string;
  img: string;
  universityCardName: string;
  path: string;
  setUniversityCardName: (id: string) => void;
}

const UniversityProgramsCardDesk: FC<IUniversityProgramsCard> = ({
  currentTab,
  name,
  img,
  universityCardName,
  path,
  setUniversityCardName,
}) => {
  const card = (
    <div className="university-programs-card-content">
      <span className="corner top-right"></span>
      <span className="corner bottom-left"></span>
      <div className="university-programs-card-img">
        <img src={img} alt="Img" />
      </div>
      <div className="university-programs-card-name">
        <p>{name}</p>
      </div>
    </div>
  );
  return currentTab === "qualification" ? (
    <div className={`university-programs-card ${universityCardName === name ? "active" : ""}`} onClick={() => setUniversityCardName(name)}>
      <Link to={path} className="university-programs-link">
        {card}
      </Link>
    </div>
  ) : (
    <div className={`university-programs-card ${universityCardName === name ? "active" : ""}`} onClick={() => setUniversityCardName(name)}>
      {card}
    </div>
  );
};

export default UniversityProgramsCardDesk;
